var map = {
	"./checkStat.js": 646,
	"./index.js": 288,
	"./insetInfo.js": 647
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 845;


//////////////////
// WEBPACK FOOTER
// ./src/router/middlewares nonrecursive \.js$
// module id = 845
// module chunks = 2